import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const muted = "rgba(253,251,247,0.55)";
  const body = "rgba(253,251,247,0.8)";

  return (
    <footer
      className="mt-32"
      style={{ background: "var(--ink-soft)", color: "var(--bone)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-14 gap-x-10 lg:gap-x-14 items-start">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block" aria-label="Tamoré by Tamanna — Home">
              <img
                src="/tamore-logo-light.png"
                alt="Tamoré by Tamanna"
                width="788"
                height="236"
                loading="lazy"
                decoding="async"
                className="block h-auto w-[180px] sm:w-[220px] lg:w-[260px]"
                style={{
                  userSelect: "none",
                  imageRendering: "-webkit-optimize-contrast",
                }}
                draggable={false}
                data-testid="footer-brand-logo"
              />
            </Link>
            <p
              className="mt-6 text-sm leading-relaxed max-w-[22rem]"
              style={{ color: body }}
              data-testid="footer-brand-description"
            >
              Thoughtfully designed pieces created to be worn, loved, and returned to season after season.
            </p>
          </div>

          {/* Maison */}
          <div className="md:col-span-2 md:col-start-7">
            <p
              className="tracking-overline text-[11px] uppercase mb-5"
              style={{ color: muted }}
            >
              Maison
            </p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" style={{ color: body }}>About Tamoré</Link></li>
              <li><Link to="/shipping-delivery" style={{ color: body }}>Shipping & Delivery</Link></li>
              <li><Link to="/contact" style={{ color: body }}>Contact</Link></li>
            </ul>
          </div>

          {/* Client Care */}
          <div className="md:col-span-2 md:col-start-9">
            <p
              className="tracking-overline text-[11px] uppercase mb-5"
              style={{ color: muted }}
            >
              Client Care
            </p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/sizing-fit" style={{ color: body }}>Sizing & Fit</Link></li>
              <li><Link to="/exchanges-returns" style={{ color: body }}>Exchanges & Returns</Link></li>
              <li><Link to="/care-instructions" style={{ color: body }}>Care Instructions</Link></li>
              <li><Link to="/faq" style={{ color: body }}>FAQ</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3 md:col-start-11">
            <p
              className="tracking-overline text-[11px] uppercase mb-5"
              style={{ color: muted }}
            >
              Contact
            </p>
            <ul className="space-y-3 text-sm" data-testid="footer-contact">
              <li>
                <a
                  href="mailto:support@tamorebytamanna.com"
                  style={{ color: body }}
                  className="hover:opacity-100 transition-opacity"
                  data-testid="footer-email"
                >
                  support@tamorebytamanna.com
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/tamorebytamanna"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: body }}
                  data-testid="footer-instagram"
                >
                  @tamorebytamanna
                </a>
              </li>
              <li style={{ color: body }}>New Delhi, India</li>
            </ul>
          </div>
        </div>

        <div
          className="mt-20 pt-8 border-t flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs"
          style={{ borderColor: "rgba(253,251,247,0.15)", color: muted }}
        >
          <p>© {new Date().getFullYear()} TAMORÉ by Tamanna · tamorebytamanna.com</p>
          <p className="italic font-display text-base" data-testid="footer-statement">
            Designed to endure.
          </p>
        </div>
      </div>
    </footer>
  );
}
